module.exports = __webpack_public_path__ + "img/ic-amex-no-color.1df6b8d2.svg";